module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row justify-center gutter-md"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('project-businesskit-assignement', {
    staticClass: "project-assignment-row",
    attrs: {
      "businesskits": _vm.businesskits,
      "assigned-businesskits": _vm.assigned_businesskits
    },
    on: {
      "update": _vm.updateBusinesskits
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('project-user-assignement', {
    staticClass: "project-assignment-row",
    attrs: {
      "users": _vm.users,
      "assigned-users": _vm.assigned_users
    },
    on: {
      "update": _vm.updateUsers
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-782b2503","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/ProjectAssignments.vue
// module id = 1950
// module chunks = 0